import { IWidgetItems } from 'shared/components/AdPlatformWidgets/components/types';

import get from 'lodash/get';

export const getWidgetParams = (widgetItem: IWidgetItems) => {
  return {
    source: get(widgetItem, 'children.0.source.Web', ''),
    aspectRatio: get(widgetItem, 'children.0.source.Web_aspect_ratio', 1),
    title: get(widgetItem, 'parameters.title') || get(widgetItem, 'parameters.title_plain'),
    description: get(widgetItem, 'parameters.description'),
    trackingData: get(widgetItem, 'trackingData'),
    pinnedProductIds: get(widgetItem, 'parameters.focus_products', ''),
  };
};
